import * as types from '../actions/types';

const initialState = {
  filters: {
    years: null,
    terms: null,
    faculties: null,
    examTypes: null,
    groups: null,
    disciplines: null,
    gradeValues: null,
  },
  data: null,
  loading: false,
};

export default function certification(state = initialState, action) {
  switch (action.type) {
    case types.SET_CERT_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case types.SET_CERT_DATA:
      return { ...state, data: action.payload };

    case types.SET_CERT_LOADING:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
}
